import React from 'react';
import CustomFormInput from './CustomFormInput';

export default class CustomTextField extends CustomFormInput {
    getElement() {
        return this.props.children;
    }
}